import type { WidgetDefinition } from "@nexus/widget-sdk";
import { Component, defaultConfig, getDataRequirements, manifest } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: manifest.id,
  module: { manifest, Component, defaultConfig, getDataRequirements },
  catalog: {
    description: manifest.description,
    domain: "audience",
    visual: "Spotlight",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content" },
  settings,
  // It chooses the blocking period on show; the host rotates it and passes it to linked charts.
  links: { blockingPeriodSelection: { role: "driver", dataKey: "series" } },
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
